import { gql } from '@apollo/client';

const Fragments = {
  financialProductRuleEditItem: gql`
    fragment financialProductRuleEditItem on FinancialProductRuleEditItem {
      financialProductRuleId
      productId
      orderNo
      ruleCode
      ruleDescription
      generalYN
      filterCondition
    }
  `,
  financialProductRuleEditFilterItem: gql`
    fragment financialProductRuleEditFilterItem on FinancialProductRuleEditFilterItem {
      filterId
      financialProductRuleId
      paramId
      operatorId
      orderNo
      filterValue
      filterValueId
      paramName
      operatorName
      paramIsList
      operatorIsMultipleSelection
    }
  `,
  financialProductRuleEditFilterValueItem: gql`
    fragment financialProductRuleEditFilterValueItem on FinancialProductRuleEditFilterValueItem {
      financialProductRuleConditionValueId
      filterId
      filterValue
      filterValueId
    }
  `,
  financialProductRuleEditOutputDataItem: gql`
    fragment financialProductRuleEditOutputDataItem on FinancialProductRuleEditOutputDataItem {
      financialProductRuleOutputDataId
      financialProductRuleId
      readOnlyYN
      paramId
      paramName
      defaultValue
      minValue
      maxValue
    }
  `
};

export default Fragments;
